var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7277 1.63623L9.48509 14.3642L8.07088 12.9499C6.50878 11.3878 6.50878 8.85518 8.07088 7.29308L13.7277 1.63623Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7277 1.63623L1 5.87938L2.41421 7.29359C3.97631 8.85569 6.50878 8.85518 8.07088 7.29308L13.7277 1.63623Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7277 1.63623L9.48509 14.3642L8.07088 12.9499C6.50878 11.3878 6.50878 8.85518 8.07088 7.29308M13.7277 1.63623L8.07088 7.29308M13.7277 1.63623L1 5.87938L2.41421 7.29359C3.97631 8.85569 6.50878 8.85518 8.07088 7.29308",
    stroke: "#0A255C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconWhite);
export default __webpack_public_path__ + "static/media/ButtonIconWhite.c3cecd9414bc679af806235f0591a3d8.svg";
export { ForwardRef as ReactComponent };